import {
  Box,
  Circle,
  Divider,
  Flex,
  HStack,
  Icon,
  Spacer,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useContext, useMemo } from 'react';

import Content from '~/containers/Content';
import PageContainer from '~/containers/PageContainer';
import SectionContainer from '~/containers/SectionContainer';

import CouponItem from '~/components/CouponItem';

import { useRecoilValue } from 'recoil';
import authAtom from '~/recoil/atom/auth';

import { useNavigate, useParams } from 'react-router-dom';

import useCoupons from './hooks/useCoupons';

import { DisplayStoresContext } from '~/provider/DisplayStoresProvider';

import * as fp from 'lodash/fp';

import { IoWalletSharp } from 'react-icons/io5';
import { Coupon } from '~/icons';
import customerAtom from '~/recoil/atom/customer';
import { FetchingDataStatus } from '~/types/utilities';
import MemberCenter from '../MemberCenter';

export default function CouponOverview() {
  const auth = useRecoilValue(authAtom);
  const customer = useRecoilValue(customerAtom);

  const navigate = useNavigate();
  const { groupId = '' } = useParams();

  const { stores } = useContext(DisplayStoresContext);

  const { coupons, couponFetchingStatus } = useCoupons(auth);

  const storeNameMap = useMemo(() => {
    return new Map(stores.map(({ name, objectID }) => [objectID, name]));
  }, [stores]);

  const filteredCoupons = useMemo(() => {
    return coupons.filter(fp.prop('allowDisplay'));
  }, [coupons]);

  return (
    <PageContainer topBoxStyle={{ position: 'static' }}>
      <Box p={4}>
        <Content>
          <VStack align="stretch" spacing={4}>
            <SectionContainer
              title="專屬優惠"
              icon={<Icon as={Coupon} color="secondary" boxSize="1.25rem" />}
            >
              <MemberCenter customer={customer} />

              <HStack
                bg="#674E29"
                borderRadius="5px"
                justify="space-between"
                align="center"
                height="40px"
                pl="5px"
                pr="10px"
                mt="20px"
              >
                <HStack alignItems="center" justifyContent="center">
                  <Icon
                    p="4px"
                    fontSize="26px"
                    as={IoWalletSharp}
                    bg="#FFF"
                    color="#674E29"
                    borderRadius="100%"
                  />
                  <Text color="#FFF" fontSize="14px" fontWeight={400}>
                    目前已賺優惠
                  </Text>
                </HStack>
                <Text color="#FFF" fontSize="14px" fontWeight={700}>
                  NT$ {(customer?.totalDiscount || 0).toLocaleString()}
                </Text>
              </HStack>
            </SectionContainer>

            <SectionContainer
              title="優惠券"
              icon={<Icon as={Coupon} color="secondary" boxSize="1.25rem" />}
              rightHandComponent={
                <>
                  {fp.gt(filteredCoupons.length, 0) && (
                    <>
                      <Circle bgColor="red" w="1rem" h="1rem">
                        <Text color="white" fontSize="xs">
                          {filteredCoupons.length}
                        </Text>
                      </Circle>
                      <Spacer />
                    </>
                  )}
                </>
              }
            >
              <Divider borderColor="primary" borderWidth="1px" />
              {fp.cond([
                [
                  fp.eq(FetchingDataStatus.LOADING),
                  fp.always(
                    <Flex justify="center" py={6}>
                      <Spinner size="lg" />
                    </Flex>,
                  ),
                ],
                [
                  fp.T,
                  fp.always(
                    <VStack py={4} align="stretch">
                      {filteredCoupons.map((coupon) => (
                        <CouponItem
                          coupon={{
                            ...coupon,
                            storesName: coupon.stores
                              .map((id) => storeNameMap.get(id) || '')
                              .filter((name) => !!name),
                          }}
                          key={coupon.id}
                          onViewDetail={() => navigate(`${coupon.id}`)}
                          onNavigate={() =>
                            navigate(groupId ? `/group/${groupId}/filterMeal` : `/filterMeal`)
                          }
                        />
                      ))}
                    </VStack>,
                  ),
                ],
              ])(couponFetchingStatus)}
            </SectionContainer>
          </VStack>
        </Content>
      </Box>
    </PageContainer>
  );
}
